<script setup lang="ts">
import { ANCHOR_STYLE } from '~/constants/ui'
import type { AnchorType } from '~/types/styles.model'

const anchorSize = {
  'regular': 'anchor--regular',
  'large-adaptive': 'anchor--large-adaptive',
} as const

type AnchorSize = keyof typeof anchorSize

const props = withDefaults(defineProps<{
  to: string
  size?: AnchorSize
  type?: AnchorType
  target?: string | null
}>(), {
  size: 'regular',
  type: 'default',
  target: null,
})

const emit = defineEmits<{
  click: []
}>()

const isButton = props.type !== 'default'
</script>

<template>
  <NuxtLink
    :to="to"
    class="app-anchor"
    :class="[`${ANCHOR_STYLE[type]}`, anchorSize[size], {'anchor--btn': isButton}]"
    active-class="active"
    :target="target"
    @click="emit('click')"
  >
    <slot />
  </NuxtLink>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/buttons';

.anchor--btn {
  @extend %app-btn-base;
}

.anchor--primary {
  @extend %app-btn-primary;
}

.anchor--secondary {
  @extend %app-btn-secondary;
}

.anchor--dark-blue {
  @extend %app-btn-dark-blue;
}

.anchor--btn.anchor--regular {
  @extend %app-btn-size-regular;
}

.anchor--btn.anchor--large-adaptive {
  @extend %app-btn-size-large-adaptive;
}
</style>
